export function getStudentLessonLink(event) {
  return event?.lessonLink || event?.zoomLink || null;
}

export function getTeacherLessonLink(event) {
  return (
    event?.teacherLessonLink ||
    event?.zoomStartLink ||
    event?.lessonLink ||
    event?.zoomLink ||
    null
  );
}

/** True until the lesson end time; false once the class has finished. */
export function isLessonJoinAvailable(event, now = new Date()) {
  if (!event?.end) return false;
  const end = event.end instanceof Date ? event.end : new Date(event.end);
  return end > now;
}

/** New events use hasVideoCall; legacy events still carry Daily/Zoom URLs on the doc. */
export function eventHasJoinableCall(event) {
  return Boolean(
    event?.hasVideoCall ||
      getStudentLessonLink(event) ||
      getTeacherLessonLink(event)
  );
}

export function canStudentJoinLesson(event, now = new Date()) {
  return Boolean(eventHasJoinableCall(event) && isLessonJoinAvailable(event, now));
}

export function canTeacherJoinLesson(event, now = new Date()) {
  return Boolean(eventHasJoinableCall(event) && isLessonJoinAvailable(event, now));
}

/** In-app lesson room path (Daily embed + annotations). */
export function getLessonRoomPath(eventId) {
  if (!eventId) return null;
  return `/lesson/${eventId}`;
}

/**
 * Parse a Daily Prebuilt-style join URL into room URL + meeting token.
 * Expected: https://domain.daily.co/room-name?t=TOKEN
 */
export function parseDailyJoinUrl(joinUrl) {
  if (!joinUrl || typeof joinUrl !== "string") return null;
  try {
    const url = new URL(joinUrl);
    const token = url.searchParams.get("t");
    if (!token) return null;
    url.search = "";
    url.hash = "";
    const roomUrl = url.toString().replace(/\/$/, "");
    return { roomUrl, token };
  } catch {
    return null;
  }
}

/**
 * Resolve Daily credentials from eventSecrets (preferred) or legacy fields on the event.
 * @param {object} event - calendar event fields
 * @param {object|null} secrets - eventSecrets/{eventId} data
 * @param {"student"|"teacher"} role
 */
export function getDailyCredentialsForRole(event, role, secrets = null) {
  const source = secrets
    ? {
        ...event,
        lessonLink: secrets.lessonLink ?? event?.lessonLink,
        teacherLessonLink:
          secrets.teacherLessonLink ?? event?.teacherLessonLink,
        zoomLink: event?.zoomLink,
        zoomStartLink: event?.zoomStartLink,
      }
    : event;

  const joinUrl =
    role === "teacher"
      ? getTeacherLessonLink(source)
      : getStudentLessonLink(source);
  return parseDailyJoinUrl(joinUrl);
}
